import React from "react";
import { useLocation } from "react-router-dom";
import { getHREF } from "../../services/KeyService";

// Shared with plain links in MarkdownWithTOC so both kinds of link look the same.
export const markdownLinkClassName =
    "text-black font-[inherit] underline decoration-dotted decoration-[#52b285] hover:text-[#52b285] decoration-[1.5px] underline-offset-[2px]";

export function Key(props) {
    const location = useLocation();
    const href = props.href
        ? props.href
        : getHREF(props.children, location.pathname);
    return (
        <a
            href={href}
            className={props.className ? props.className : markdownLinkClassName}
        >
            {props.children}
        </a>
    );
}
